export function minMaxValue(initialVal) {
  this.fValue = initialVal;
  this.fSkipFirst = false;
}
